module.exports = __webpack_public_path__ + "static/media/default-empty.6ae27f26.jpeg";